// Telefon sprawdza nową wersję service workera tylko przy wejściu na stronę, a
// aplikacja z ekranu startowego zwykle się nie uruchamia od nowa, tylko wraca
// z tła. Dlatego pytamy o aktualizację przy każdym powrocie do aplikacji (i co
// godzinę — `periodicSyncForUpdates` w nuxt.config). Przy `autoUpdate` nowy
// service worker aktywuje się od razu, a strona sama się przeładowuje.
const MIN_INTERVAL = 60 * 1000

export default defineNuxtPlugin((nuxtApp) => {
    let registration: ServiceWorkerRegistration | undefined
    let lastCheck = 0

    nuxtApp.hook('service-worker:registered', ({ registration: r }) => {
        registration = r
    })

    const check = () => {
        if (!registration || registration.installing || !navigator.onLine) return
        if (Date.now() - lastCheck < MIN_INTERVAL) return
        lastCheck = Date.now()
        registration.update().catch(() => {
            // Brak sieci albo serwer chwilowo niedostępny — spróbujemy przy kolejnym powrocie.
        })
    }

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') check()
    })
    window.addEventListener('online', check)
})
